import styled from 'styled-components';
import { Card } from 'antd';

export const ContainerDashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const DashboardHero = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 28px;
  border-radius: 26px;
  background:
    radial-gradient(
      circle at 15% 18%,
      rgba(255, 255, 255, 0.12),
      transparent 28%
    ),
    linear-gradient(145deg, #155d4b 0%, #1f725f 58%, #356d9f 100%);
  box-shadow: 0 24px 60px rgba(18, 62, 51, 0.14);

  @media (max-width: 880px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
`;

export const DashboardHeader = styled.div`
  .eyebrow {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 0.74rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-weight: 700;
    color: rgba(241, 255, 248, 0.74);
  }

  h2.ant-typography {
    color: #ffffff;
  }

  .user-name {
    color: #f8e7c6;
  }

  .subtitle {
    display: inline-block;
    margin-top: 10px;
    font-size: 1rem;
    color: rgba(241, 255, 248, 0.84);
    line-height: 1.65;
    max-width: 42ch;
  }
`;

export const DashboardQuickActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  .ant-btn {
    height: 46px;
    border-radius: 14px;
    font-weight: 700;
  }

  .ant-btn:not(.ant-btn-primary) {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }
`;

export const MetricCard = styled(Card)`
  border: 1px solid rgba(24, 90, 66, 0.08) !important;
  background: linear-gradient(180deg, #ffffff 0%, #fbfefd 100%);

  .ant-card-actions {
    background: transparent;
    border-top: 1px solid rgba(24, 90, 66, 0.08);
  }

  .ant-card-actions > li {
    margin: 10px 0;
  }

  .ant-statistic {
    min-height: 114px;
  }

  .ant-statistic-content {
    letter-spacing: -0.03em;
  }
`;

export const SectionTitle = styled.h2`
  margin: 6px 0 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #174638;
  letter-spacing: -0.01em;
`;

export const ContainerSaudation = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SaudationText = styled.p`
  font-size: 20px;
`;

export const SaudationNameUserText = styled.p`
  font-size: 20px;
  font-weight: 700;
  margin-left: 5px;
  color: #87d069;
`;

export const CardRowIcons = styled.div`
  text-align: center;
`;

export const ButtonCard = styled.div``;

export const ContainerDescriptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IDescriptionTextProps {
  bold?: boolean;
}
export const DescriptionText = styled.div<IDescriptionTextProps>`
  font-weight: ${(props) => (props.bold ? 'bold' : 400)};
  color: #000;
  margin-right: ${(props) => (props.bold ? 5 : 0)}px;
`;

export const RowDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContainerRowModalTitle = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 25px;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  white-space: normal;
`;
